import { Link } from 'react-router-dom';
import { homepageLongContent, seoFaq } from '@/mocks/seoContent';

export default function SEOContent() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <article>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
            Complete Guide to Vigorbuy Spreadsheet
          </h2>

          <div className="text-foreground-700 leading-relaxed space-y-5 text-sm md:text-base">
            {homepageLongContent.split('\n\n').filter(p => p.trim()).map((paragraph, idx) => (
              <p key={idx}>
                {paragraph.trim()}
              </p>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/vigorbuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-article-line"></i>
              Read Complete Vigorbuy Spreadsheet Guide
            </Link>
          </div>
        </article>

        <div className="mt-14">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
            Frequently Asked Questions
          </h3>

          <div className="space-y-4">
            {seoFaq.map((faq) => (
              <details
                key={faq.question}
                className="group bg-background-100 rounded-xl border border-background-200/50 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/70 transition-colors duration-200">
                  <span className="text-sm font-semibold text-foreground-800 pr-4">{faq.question}</span>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform duration-200"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>

        <div className="mt-14 p-8 bg-primary-50/60 rounded-2xl border border-primary-200/50 text-center">
          <h4 className="font-heading text-xl font-bold text-foreground-900 mb-3">
            Ready to Explore Vigorbuy Spreadsheet?
          </h4>
          <p className="text-sm text-foreground-600 mb-5 max-w-lg mx-auto">
            Visit our main store to discover the full range of products and start your data management journey today.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line"></i>
            Visit Vigorbuy Main Store
          </a>
        </div>
      </div>
    </section>
  );
}